import PropTypes from 'prop-types';

export const crossSellOfferType = PropTypes.shape({
  index: PropTypes.number,
  intRate: PropTypes.number,
  maxAmount: PropTypes.number,
  minAmount: PropTypes.number,
  rateDiscountResponse: PropTypes.array,
  rateType: PropTypes.string,
  term: PropTypes.number,
});
export const crossSellOfferPackageType = PropTypes.shape({
  applicationUuid: PropTypes.string,
  crossSellApplicationUuid: PropTypes.string,
  decision: PropTypes.string,
  identityUuid: PropTypes.string,
  lienVerificationRequired: PropTypes.bool,
  max: PropTypes.number,
  maxLoanAmountByProduct: PropTypes.number,
  min: PropTypes.number,
  offers: PropTypes.arrayOf(crossSellOfferType),
  productType: PropTypes.string,
  subDecision: PropTypes.string,
  termsList: PropTypes.arrayOf(PropTypes.number),
});
export const crossSellOfferPackagesType = PropTypes.arrayOf(crossSellOfferPackageType);
